import { render, staticRenderFns } from "./user-add-or-update.vue?vue&type=template&id=1b2c3250&scoped=true&"
import script from "./user-add-or-update.vue?vue&type=script&lang=js&"
export * from "./user-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./user-add-or-update.vue?vue&type=style&index=0&id=1b2c3250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2c3250",
  null
  
)

export default component.exports